export default {
    common: {
        loading: {
            es: 'Cargando',
            en: 'Loading',
            it: 'Loading',
            fr: 'Loading',
            de: 'Loading',
            da: 'Indlæser',
        },
    },
    translate: {
        title: {
            es: 'Traducir',
            en: 'Translate',
            it: 'Traduire',
            fr: 'Traduire',
            de: 'Übersetzen',
            da: 'Oversæt',
        },
        from: {
            es: 'De',
            en: 'From',
            it: 'Dal',
            fr: 'De',
            de: 'From',
            da: 'Fra',
        },
        to: {
            es: 'a',
            en: 'to',
            it: 'allo',
            fr: 'à',
            de: 'to',
            da: 'til',
        },
        languageNotDetected: {
            es: 'Idioma no detectado',
            en: 'Source language not detected',
            it: 'Lingua sorgente non rilevata',
            fr: 'Langue source non détectée',
            de: 'Quellsprache nicht erkannt',
            da: 'Kildesprog ikke registreret',
        },
        errors: {
            'no-results': {
                message: {
                    es: 'No pudimos realizar la traducción, ',
                    en: 'We could not perform the translation, ',
                    it: 'Non siamo riusciti a eseguire la traduzione, ',
                    fr: "Nous n'avons pas pu effectuer la traduction, ",
                    de: 'We could not perform the translation, ',
                    da: 'Vi kunne ikke udføre oversættelsen, ',
                },
                suggestion: {
                    es: 'intenta nuevamente.',
                    en: 'try again.',
                    it: 'riprova.',
                    fr: 'essayez à nouveau.',
                    de: 'try again.',
                    da: 'prøv igen.',
                },
            },
        },
    },
    listen: {
        title: {
            es: 'Escuchar',
            en: 'Listen',
            it: 'Ascoltare',
            fr: 'écouter',
            de: 'Abspielen',
            da: 'Lyt',
        },
        playing: {
            es: 'Reproduciendo',
            en: 'Playing',
            it: 'Riproduzione',
            fr: 'Lecture',
            de: 'Wiedergabe',
            da: 'Afspiller',
        },
        errors: {
            'no-results': {
                message: {
                    es: 'No pudimos realizar la conversión, ',
                    en: 'We could not perform the conversion, ',
                    it: 'Non siamo riusciti a eseguire la conversione, ',
                    fr: "Nous n'avons pas pu effectuer la conversion, ",
                    de: 'We could not perform the conversion, ',
                    da: 'Vi kunne ikke udføre konverteringen, ',
                },
                suggestion: {
                    es: 'intenta nuevamente.',
                    en: 'try again.',
                    it: 'riprova.',
                    fr: 'essayez à nouveau.',
                    de: 'try again.',
                    da: 'prøv igen.',
                },
            },
        },
    },
    dictionary: {
        errors: {
            'no-results': {
                message: {
                    es: 'No hay resultados, intenta con otra búsqueda.',
                    en: 'No results, try another search.',
                    it: "Nessun risultato, prova un'altra ricerca.",
                    fr: 'Aucun résultat, essayez une autre recherche.',
                    de: 'No results, try another search.',
                    da: 'Ingen resultater, prøv en anden søgning.',
                },
            },
        },
    },
    'ai-integrations': {
        errors: {
            'no-results': {
                message: {
                    es: 'Algo salió mal. Intenta nuevamente. Recuerda que esta función está en fase BETA, por lo que puede devolver datos inesperados.',
                    en: 'Something went wrong. Please try again. Remember that this feature is in BETA, so it may return unexpected data.',
                    it: 'Qualcosa è andato storto. Per favore riprova. Ricorda che questa funzione è in fase BETA, quindi potrebbe restituire dati inattesi.',
                    fr: "Quelque chose s'est mal passé. Veuillez réessayer. N'oubliez pas que cette fonction est en phase BETA, elle peut donc renvoyer des données inattendues.",
                    de: 'Etwas ist schief gelaufen. Bitte versuchen Sie es erneut. Denken Sie daran, dass diese Funktion in der BETA-Phase ist und unerwartete Daten zurückgeben kann.',
                    da: 'Noget gik galt. Prøv venligst igen. Husk at denne funktion er i BETA, så den kan returnere uventede data.',
                },
            },
            'empty-response': {
                message: {
                    es: 'Hmm, parece que no pude generar una respuesta esta vez. ¿Intentamos de nuevo?',
                    en: "Hmm, I wasn't able to generate a response this time. Shall we try again?",
                    it: 'Hmm, non sono riuscito a generare una risposta questa volta. Proviamo di nuovo?',
                    fr: "Hmm, je n'ai pas pu générer une réponse cette fois. Essayons encore?",
                    de: 'Hmm, ich konnte diesmal keine Antwort generieren. Sollen wir es nochmal versuchen?',
                    da: 'Hmm, jeg kunne ikke generere et svar denne gang. Skal vi prøve igen?',
                },
            },
            'invalid-response': {
                message: {
                    es: 'Algo no funcionó como esperaba. ¿Probamos otra vez?',
                    en: "Something didn't work as expected. Shall we try again?",
                    it: 'Qualcosa non ha funzionato come previsto. Proviamo di nuovo?',
                    fr: "Quelque chose n'a pas fonctionné comme prévu. Essayons encore?",
                    de: 'Etwas hat nicht wie erwartet funktioniert. Sollen wir es nochmal versuchen?',
                    da: 'Noget fungerede ikke som forventet. Skal vi prøve igen?',
                },
            },
        },
        retry: {
            es: 'Intentar de nuevo',
            en: 'Try again',
            it: 'Riprova',
            fr: 'Réessayer',
            de: 'Nochmal versuchen',
            da: 'Prøv igen',
        },
        loading: {
            es: {
                generating: 'Generando respuesta',
                processing: 'Procesando',
                wait: 'Por favor espere',
                getting: 'Obteniendo datos',
                analyzing: 'Analizando datos',
            },
            en: {
                generating: 'Generating response',
                processing: 'Processing',
                wait: 'Please wait',
                getting: 'Getting data',
                analyzing: 'Analyzing data',
            },
            de: {
                generating: 'Antwort wird generiert',
                processing: 'Verarbeitung',
                wait: 'Bitte warten',
                getting: 'Daten werden abgerufen',
                analyzing: 'Daten werden analysiert',
            },
            fr: {
                generating: 'Génération de la réponse',
                processing: 'Traitement',
                wait: 'Veuillez patienter',
                getting: 'Récupération des données',
                analyzing: 'Analyse des données',
            },
            it: {
                generating: 'Generazione della risposta',
                processing: 'Elaborazione',
                wait: 'Attendere prego',
                getting: 'Recupero dei dati',
                analyzing: 'Analisi dei dati',
            },
            pt: {
                generating: 'Gerando resposta',
                processing: 'Processando',
                wait: 'Por favor, aguarde',
                getting: 'Obtendo dados',
                analyzing: 'Analisando dados',
            },
            da: {
                generating: 'Genererer svar',
                processing: 'Behandler',
                wait: 'Vent venligst',
                getting: 'Henter data',
                analyzing: 'Analyserer data',
            },
        },
    },
};
